import { c as _c } from "react/compiler-runtime";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, toast, useProfile } from "../../../../global-account/react/index.js";
import { validateImageUrl } from "../../../../global-account/react/utils/profileDisplay.js";
import { truncateAddress } from "../../../../shared/utils/truncateAddress.js";
import { Copy, Loader2, UnlinkIcon } from "lucide-react";
// Helper function to check if a string is a wallet address and format it
const formatProfileTitle = title => {
  // Check if title looks like an Ethereum address (0x followed by 40 hex characters)
  const isEthereumAddress = /^0x[a-fA-F0-9]{40}$/.test(title);
  if (isEthereumAddress) {
    return {
      displayTitle: truncateAddress(title),
      isAddress: true
    };
  }
  return {
    displayTitle: title,
    isAddress: false
  };
};
const LinkedAccountItem = t0 => {
  const $ = _c(7);
  const {
    profile,
    profileToUnlink,
    unlinkingAccountId,
    isUnlinking,
    onUnlinkClick
  } = t0;
  const {
    displayTitle,
    isAddress
  } = formatProfileTitle(profile.title);
  let t1;
  if ($[0] !== profile.title) {
    t1 = {
      address: profile.title
    };
    $[0] = profile.title;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    data: profileData
  } = useProfile(t1);
  let t2;
  if ($[2] !== profile.title) {
    t2 = async e => {
      e.stopPropagation();
      ;
      try {
        await navigator.clipboard.writeText(profile.title);
        toast.success("Address copied to clipboard!");
      } catch (t3) {
        toast.error("Failed to copy address");
      }
    };
    $[2] = profile.title;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const handleCopyAddress = t2;
  const displayImageUrl = validateImageUrl(profileData?.avatar) || validateImageUrl(profile.imageUrl);
  const displayName = profileData?.name || displayTitle;
  let t3;
  if ($[4] !== onUnlinkClick || $[5] !== profile) {
    t3 = () => onUnlinkClick(profile);
    $[4] = onUnlinkClick;
    $[5] = profile;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return _jsxs("div", {
    className: "linked-account-item hover:bg-b3-line group flex cursor-pointer items-center justify-between rounded-xl p-4 transition-colors",
    children: [_jsxs("div", {
      className: "linked-account-info flex items-center gap-3",
      children: [displayImageUrl ? _jsx("img", {
        src: displayImageUrl,
        alt: profile.title,
        className: "linked-account-avatar linked-account-avatar-image size-10 rounded-full"
      }) : _jsx("div", {
        className: "linked-account-avatar linked-account-avatar-placeholder bg-b3-primary-wash flex h-10 w-10 items-center justify-center rounded-full",
        children: _jsx("span", {
          className: "linked-account-initial text-b3-grey font-neue-montreal-semibold text-sm uppercase",
          children: profile.initial
        })
      }), _jsxs("div", {
        className: "linked-account-details",
        children: [_jsxs("div", {
          className: "linked-account-title-row flex items-center gap-2",
          children: [_jsxs("div", {
            className: "flex items-center gap-1",
            children: [_jsx("span", {
              className: `linked-account-title text-b3-grey font-neue-montreal-semibold ${isAddress ? "font-mono text-sm" : "break-words"}`,
              title: isAddress ? profile.title : undefined,
              children: displayName
            }), isAddress && _jsx("button", {
              onClick: handleCopyAddress,
              className: "linked-account-copy-button ml-1 rounded p-1 opacity-0 transition-opacity hover:bg-gray-100 group-hover:opacity-100",
              title: "Copy full address",
              children: _jsx(Copy, {
                size: 12,
                className: "text-gray-500 hover:text-gray-700"
              })
            })]
          }), _jsx("span", {
            className: "linked-account-type text-b3-foreground-muted font-neue-montreal-medium bg-b3-primary-wash rounded px-2 py-0.5 text-xs",
            children: profile.type.toUpperCase()
          })]
        }), _jsx("div", {
          className: "linked-account-subtitle text-b3-foreground-muted font-neue-montreal-medium text-sm",
          children: profile.subtitle
        })]
      })]
    }), _jsx(Button, {
      variant: "ghost",
      size: profileToUnlink?.title === profile.title ? "sm" : "icon",
      className: `linked-account-unlink-button transition-all ${profileToUnlink?.title === profile.title ? "bg-b3-negative hover:bg-b3-negative/90 text-white" : "text-b3-grey hover:text-b3-negative"}`,
      onClick: t3,
      disabled: unlinkingAccountId === profile.title || isUnlinking,
      children: unlinkingAccountId === profile.title || isUnlinking ? _jsx(Loader2, {
        className: "linked-account-unlink-loading h-4 w-4 animate-spin"
      }) : profileToUnlink?.title === profile.title ? _jsxs("div", {
        className: "flex items-center gap-1.5",
        children: [_jsx(UnlinkIcon, {
          size: 14,
          className: "linked-account-unlink-icon"
        }), _jsx("span", {
          className: "text-xs font-semibold",
          children: "Unlink"
        })]
      }) : _jsx(UnlinkIcon, {
        size: 16,
        className: "linked-account-unlink-icon"
      })
    })]
  });
};
export default LinkedAccountItem;